<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modalAddMenuset"
      id="show-modal-add-menuset"
    ></material-button>
    <material-button
      class="d-none"
      data-bs-dismiss="modal"
      data-bs-target="#modalAddMenuset"
      id="hide-modal-add-menuset"
    ></material-button>
    
    <div
      class="modal fade"
      id="modalAddMenuset"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ isEditMenuset ? "Edit Menuset" : "Add Menuset" }}
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              @click="closeModal()"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div
              class="w-100"
              :class="{ 'mb-3': !fieldRequired.isMenuNameRequire }"
            >
              <label class="fw-bold" for=""
                >Menu Name
                <span class="text-danger">*</span>
              </label>
              <material-input
                v-model="menuSet.name"
                type="text"
                id="menuset_name"
                name="menuset_name"
                placeholder="Enter name"
              />
            </div>
            <div class="w-100 mb-3">
              <span class="is-invalid" v-if="fieldRequired.isMenuNameRequire"
                >The field is required.</span
              >
            </div>
            <div class="w-100 mb-3">
              <label class="fw-bold" for="">POS English Name</label>
              <Multiselect
                v-model="menuSet.pos_name"
                :options="types"
                :canClear="false"
                placeholder="Type"
              />
            </div>
            <div class="w-100 mb-3">
              <span class="is-invalid" v-if="fieldRequired.isPosNameRequire"
                >The field is required.</span
              >
            </div>
            <div class="w-100 mb-3">
              <label class="fw-bold" for="">POS Name 2</label>
              <Multiselect
                v-model="menuSet.pos_description"
                :options="types"
                :canClear="false"
                placeholder="Type"
              />
            </div>
            <div class="w-100 mb-3">
              <span class="is-invalid" v-if="fieldRequired.isPosDescriptionRequire"
                >The field is required.</span
              >
            </div>
            <!-- Grab Menu Sections Schedule -->
            <div class="w-100 mb-3">
              <label class="fw-bold text-warning" for="">Grab Menu Sections</label>
              <table class="table table-bordered table-sm mt-2 mb-0" style="font-size: 13px; border-collapse: collapse;">
                <thead>
                  <tr>
                    <th style="width: 110px;">Day</th>
                    <th style="width: 140px;">Period Type</th>
                    <th>Period</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(schedule, idx) in menuSet.grab_schedules" :key="idx">
                    <td class="align-middle">{{ schedule.day }}</td>
                    <td>
                      <select
                        class="form-select form-select-sm"
                        v-model="schedule.periodType"
                        @change="onPeriodTypeChange(idx)"
                      >
                        <option :value="1">Open Period</option>
                        <option :value="2">Open All Day</option>
                        <option :value="3">Close All Day</option>
                      </select>
                    </td>
                    <td>
                      <div v-if="schedule.periodType === 1">
                        <div
                          v-for="(period, pIdx) in schedule.periods"
                          :key="pIdx"
                          class="d-flex align-items-center mb-1"
                        >
                          <Datepicker
                            :model-value="toTimeObj(period.startTime)"
                            @update:model-value="val => onTimeChange(period, 'startTime', val)"
                            timePicker
                            :is24="true"
                            minutesIncrement="1"
                            hoursIncrement="1"
                            :clearable="false"
                            class="time-picker-24h"
                          />
                          <span class="mx-1">-</span>
                          <Datepicker
                            :model-value="toTimeObj(period.endTime)"
                            @update:model-value="val => onTimeChange(period, 'endTime', val)"
                            timePicker
                            :is24="true"
                            minutesIncrement="1"
                            hoursIncrement="1"
                            :clearable="false"
                            class="time-picker-24h"
                          />
                          <a
                            href="javascript:;"
                            class="text-danger ms-2"
                            @click="removePeriod(idx, pIdx)"
                            v-if="schedule.periods.length > 1"
                            title="Remove"
                          >
                            <i class="fas fa-minus-circle"></i>
                          </a>
                          <a
                            href="javascript:;"
                            class="text-primary ms-1"
                            @click="addPeriod(idx)"
                            title="Add period"
                          >
                            <i class="fas fa-plus-circle"></i>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              class="w-100 mb-3"
            >
              <label class="fw-bold" for=""
                >Status
              </label>
              <div class="d-flex">
                <MaterialRadio
                  id="status_1"
                  value="1"
                  class="ps-0"
                  v-model="menuSet.status"
                >
                  Active
                </MaterialRadio>
                <MaterialRadio
                  id="status_2"
                  value="0"
                  v-model="menuSet.status"
                >
                  Inactive
                </MaterialRadio>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex mt-3">
              <material-button
                class="mx-2 btn btn-sm btn-background"
                @click="saveMenu()"
              >
                {{ isEditMenuset ? "Save" : "Add Menuset" }}
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-background"
                @click="closeModal()"
              >
                Cancel
              </material-button>
            </div>
          </div>
          <material-loading :active="loaderActive" />
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MenusetService from "../services/product/menuset.service";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialRadio from "@/components/MaterialRadio.vue";
import Multiselect from "@vueform/multiselect";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { scrollToFirstInvalid } from "@/config/utils";

export default {
  name: "add-menuset",
  components: {
    MaterialInput,
    MaterialButton,
    MaterialLoading,
    MaterialSnackbar,
    MaterialRadio,
    Multiselect,
    Datepicker
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    menusetId: {
      type: Number,
      default: 0,
    },
    isEditMenuset: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      urlImagePreview: null,
      isErrorUploadImage: false,
      isImageTooSmall: false,
      messageImageError: "",
      fieldRequired: {},
      loaderActive: false,
      menuSet: {
        id: this.isEditMenuset ? this.menusetId : 0,
        name: "",
        description: "",
        image: null,
        status: 1,
        pos_name: 1,
        pos_description: 2,
        grab_schedules: [],
      },
      types: [
        {
          value: 1,
          label: "Item Name"
        },
        {
          value: 2,
          label: "Item Description"
        }
      ]
    };
  },
  methods: {
    toTimeObj(timeStr) {
      if (!timeStr || typeof timeStr !== 'string') return { hours: 0, minutes: 0, seconds: 0 };
      const [h, m] = timeStr.split(':');
      return {
        hours: parseInt(h, 10) || 0,
        minutes: parseInt(m, 10) || 0,
        seconds: 0,
      };
    },
    onTimeChange(period, field, val) {
      if (!val) {
        period[field] = '';
        return;
      }
      const hh = String(val.hours ?? 0).padStart(2, '0');
      const mm = String(val.minutes ?? 0).padStart(2, '0');
      period[field] = `${hh}:${mm}`;
    },
    initGrabSchedules() {
      const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
      return days.map(day => ({
        day,
        periodType: 2, // Open All Day
        periods: [{ startTime: '07:00', endTime: '18:00' }],
      }));
    },

    onPeriodTypeChange(idx) {
      // Ensure at least one period when switching to Open Period
      if (this.menuSet.grab_schedules[idx].periodType === 1 &&
          this.menuSet.grab_schedules[idx].periods.length === 0) {
        this.menuSet.grab_schedules[idx].periods.push({ startTime: '07:00', endTime: '18:00' });
      }
    },

    addPeriod(idx) {
      this.menuSet.grab_schedules[idx].periods.push({ startTime: '07:00', endTime: '18:00' });
    },

    removePeriod(idx, pIdx) {
      this.menuSet.grab_schedules[idx].periods.splice(pIdx, 1);
    },

    uploadFile() {
      $("#imageMenuset").click();
    },

    clearImage() {
      this.menuset.image = null;
      this.urlImagePreview = null;
      this.fieldRequired.isImageRequire = false;
      this.isErrorUploadImage = false;
      this.isImageTooSmall = false;
    },

    handleFileUpload(event) {
      this.isImageTooSmall = false;
      let file = event.target.files[0];
      if (file != null || file != undefined) {
        this.menuSet.image = null;
        this.urlImagePreview = null;
        if (
          !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
            file.type
          )
        ) {
          this.isErrorUploadImage = false;
          this.fieldRequired.isImageRequire = true;
          this.messageImageError = `File must be an image.`;
        } else {
          const maxFileSize = 1024 * 1024; // 1MB
          if (file.size > maxFileSize) {
            this.fieldRequired.isImageRequire = true;
            this.messageImageError = `File size must not exceed 1MB.`;
            return;
          }

          this.menuSet.image = file;
          this.urlImagePreview = URL.createObjectURL(file);
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (evt) => {
            let img = new Image();
            img.onload = () => {
              let width = img.width;
              let height = img.height;
              if (width < 100 || height < 100) {
                this.messageImageError = `The image width ${width} x ${height} is too small.`;
                this.fieldRequired.isImageRequire = true;
                this.isErrorUploadImage = true;
                this.isImageTooSmall = true;
              } else {
                this.fieldRequired.isImageRequire = false;
                this.isErrorUploadImage = false;
                this.isImageTooSmall = false;
                this.messageImageError = "";
              }
            };
            img.src = evt.target.result;
          };
        }
      } else {
        this.menuSet.image = null;
        this.urlImagePreview = null;
        this.isErrorUploadImage = false;
        this.messageImageError = "";
      }
    },

    getMenuDetail() {
      this.showLoader();
      var menuId = this.menusetId;
      if (menuId) {
        MenusetService.menusetDetail(menuId).then(
          (response) => {
            if (response.data.result.isSuccess) {
              const data = response.data.data;
              this.menuSet = data;
              // Ensure grab_schedules is populated; fallback to defaults
              if (!data.grab_schedules || data.grab_schedules.length === 0) {
                this.menuSet.grab_schedules = this.initGrabSchedules();
              } else {
                this.menuSet.grab_schedules = data.grab_schedules;
              }
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        );
      }
    },

    saveMenu() {
      if (this.processValidate()) {
        this.showLoader();
        var menuId = this.isEditMenuset ? this.menusetId : 0;

        // Stringify grab_schedules for multipart FormData
        const dataToSend = {
          ...this.menuSet,
          grab_schedules: JSON.stringify(this.menuSet.grab_schedules),
        };

        if (menuId) {
          dataToSend.id = menuId;
          MenusetService.update(dataToSend).then(
            (response) => {
              if (response.data.result.isSuccess) {
                this.snackbar = "success";
                this.message = "Update MenuSet Success";
                this.setTimeOutNotification();
                this.hideLoader();
                this.$emit("reload-list-menuset");
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
                this.hideLoader();
              }
            },
            (error) => {
              this.snackbar = "danger";
              this.message = error.response.data.result.message;
              this.hideLoader();
              this.setTimeOutNotification();
            }
          );
        } else {
          MenusetService.store(dataToSend).then(
            (response) => {
              if (response.data.result.isSuccess) {
                this.snackbar = "success";
                this.message = "Create MenuSet Success";
                this.setTimeOutNotification();
                this.hideLoader();
                this.$emit("reload-list-menuset");
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
                this.hideLoader();
              }
            },
            (error) => {
              this.snackbar = "danger";
              this.message = error;
              this.hideLoader();
              this.setTimeOutNotification();
            }
          );
        }
      }
    },

    resetRequired() {
      this.fieldRequired.isMenuNameRequire = false;
      this.fieldRequired.isPosNameRequire = false;
      this.fieldRequired.isPosDescriptionRequire = false;
    },

    processValidate() {
      this.resetRequired();
      var isValid = true;
      if (this.menuSet.name == "" || this.menuSet.name == null) {
        this.fieldRequired.isMenuNameRequire = true;
        isValid = false;
      }

      if (this.menuSet.pos_name == "" || this.menuSet.pos_name == null) {
        this.fieldRequired.isPosNameRequire = true;
        isValid = false;
      }

      if (this.menuSet.pos_description == "" || this.menuSet.pos_description == null) {
        this.fieldRequired.isPosDescriptionRequire = true;
        isValid = false;
      }

      if (!isValid) {
        scrollToFirstInvalid();
      }

      return isValid;
    },

    closeModal() {
      this.$emit("reload-list-menuset", "cancel");
    },

    clearData() {
      this.resetRequired();
      this.menuSet = {
        id: this.isEditMenuset ? this.menusetId : 0,
        name: "",
        description: "",
        image: null,
        status: 1,
        pos_name: 1,
        pos_description: 2,
        grab_schedules: this.initGrabSchedules(),
      };
      this.urlImagePreview = null;
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    keyReload() {
      this.clearData();

      if (this.isEditMenuset) {
        this.getMenuDetail();
      }
    },
  },
};
</script>
<style scoped>
.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

.table-bordered td,
.table-bordered th {
  border: 1px solid #dee2e6 !important;
}

.modal-body .row {
  margin-top: 10px;
}

.content {
  cursor: pointer;
  text-align: center;
  width: 250px;
  height: 250px;
  margin-top: 25px;
  border: 1px solid #ccc;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #f0f2f5;
}

.font-18 {
  font-size: 18px;
}

.dowload-img {
  text-align: center;
  cursor: pointer;
  background-color: #f0f2f5;
  width: 100%;
  height: 300px;
}

.css-icon-upload {
  font-size: 45px !important;
  margin-top: 6rem;
}

.image-url {
  width: 100%;
  height: 300px;
}

.btn-edit-img {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  color: #f44335;
  font-size: 14px;
  right: 30px;
  top: 4px;
  background: #ffffff;
  border-radius: 50%;
}

.time-picker-24h {
  width: 120px;
  display: inline-block;
}
.time-picker-24h :deep(.dp__input) {
  padding: 4px 8px 4px 28px;
  font-size: 0.875rem;
  height: calc(1.5em + 0.5rem + 2px);
}
</style>
